// Copyright (c) 2020 Deere & Company

import Notifications, { getDefaultState } from '../state/notificationCollections';
import actions from '../../../sharedmodules/actions-list';

const getNotifications = (state, action) => Notifications.update(state, {
    $set: action.data,
});

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.GET_NOTIFICATION_DATA]: getNotifications,
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};
